import { render } from "./TurnOver.vue?vue&type=template&id=740e749e&scoped=true&ts=true"
import script from "./TurnOver.vue?vue&type=script&lang=ts"
export * from "./TurnOver.vue?vue&type=script&lang=ts"

import "./TurnOver.vue?vue&type=style&index=0&id=740e749e&scoped=true&lang=less"

import exportComponent from "D:\\project\\mpe-project\\vue-project\\mobile-mpe\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-740e749e"]])

export default __exports__